import React from "react";

export const Sparkle = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3348_10693)">
        <path
          d="M13.4325 7.71246C13.4325 7.4618 13.2919 7.2318 13.0679 7.1178C12.4945 6.8258 11.8805 6.55713 11.1925 6.2958C10.0552 5.8598 9.22654 5.01846 8.79587 3.8658C8.53787 3.16646 8.27254 2.5438 7.98521 1.96246C7.87254 1.7358 7.64054 1.5918 7.38787 1.5918C7.13521 1.5918 6.90187 1.7358 6.79054 1.96313C6.50387 2.54246 6.23921 3.16513 5.98121 3.86313C5.55054 5.0178 4.72121 5.85913 3.58587 6.29446C2.89387 6.5578 2.27921 6.82646 1.70787 7.1178C1.48454 7.23113 1.34387 7.46113 1.34387 7.7118C1.34387 7.96246 1.48454 8.19246 1.70854 8.30646C2.28321 8.59846 2.89721 8.8678 3.58387 9.1278C4.72121 9.5638 5.54987 10.4051 5.98054 11.5585C6.23987 12.2605 6.50454 12.8818 6.79054 13.4611C6.9032 13.6885 7.13454 13.8325 7.38787 13.8325C7.64121 13.8325 7.87321 13.6885 7.98521 13.4611C8.27254 12.8818 8.53721 12.2591 8.79454 11.5605C9.22587 10.4058 10.0559 9.56446 11.1899 9.12913C11.8792 8.8678 12.4932 8.59913 13.0679 8.30713C13.2919 8.19313 13.4325 7.9638 13.4325 7.71246Z"
          fill="url(#paint0_linear_3348_10693)"
        />
        <path
          d="M12.0738 4.36156C12.2438 4.44823 12.4112 4.51956 12.5758 4.58223C12.7138 4.63556 12.8105 4.73423 12.8625 4.87223C12.9238 5.04089 12.9938 5.20889 13.0785 5.38089C13.1898 5.60889 13.4218 5.75423 13.6758 5.75423H13.6772C13.9305 5.75423 14.1625 5.61023 14.2745 5.38289C14.3592 5.21156 14.4285 5.04289 14.4905 4.87556C14.5438 4.73423 14.6405 4.63556 14.7758 4.58356C14.9432 4.52023 15.1098 4.44889 15.2798 4.36223C15.5038 4.24889 15.6445 4.01823 15.6445 3.76756C15.6445 3.51689 15.5032 3.28689 15.2792 3.17356C15.1098 3.08823 14.9432 3.01689 14.7778 2.95356C14.6405 2.90089 14.5438 2.80223 14.4912 2.66223C14.4285 2.49356 14.3592 2.32489 14.2738 2.15289C14.1618 1.92623 13.9298 1.78223 13.6765 1.78223H13.6752C13.4212 1.78223 13.1898 1.92689 13.0778 2.15489C12.9938 2.32623 12.9238 2.49489 12.8632 2.66023C12.8098 2.80156 12.7132 2.90023 12.5778 2.95223C12.4098 3.01623 12.2432 3.08689 12.0732 3.17356C11.8492 3.28689 11.7085 3.51689 11.7085 3.76756C11.7085 4.01823 11.8492 4.24823 12.0732 4.36156H12.0738Z"
          fill="url(#paint1_linear_3348_10693)"
        />
        <path
          d="M15.6452 11.4565C15.4339 11.3492 15.2252 11.2598 15.0199 11.1825C14.7939 11.0958 14.6292 10.9278 14.5445 10.6998C14.4665 10.4892 14.3792 10.2785 14.2739 10.0652C14.1612 9.83785 13.9292 9.69385 13.6765 9.69385C13.4225 9.69385 13.1905 9.83851 13.0792 10.0665C12.9745 10.2798 12.8872 10.4898 12.8112 10.6965C12.7245 10.9278 12.5599 11.0958 12.3372 11.1812C12.1292 11.2598 11.9199 11.3492 11.7092 11.4572C11.4859 11.5712 11.3452 11.8005 11.3452 12.0512C11.3452 12.3018 11.4859 12.5312 11.7092 12.6452C11.9199 12.7525 12.1279 12.8412 12.3352 12.9205C12.5599 13.0065 12.7245 13.1738 12.8099 13.4025C12.8872 13.6125 12.9745 13.8232 13.0799 14.0358C13.1919 14.2632 13.4232 14.4072 13.6772 14.4078C13.9305 14.4078 14.1619 14.2645 14.2745 14.0372C14.3805 13.8238 14.4679 13.6132 14.5452 13.4045C14.6305 13.1738 14.7952 13.0065 15.0199 12.9205C15.2279 12.8412 15.4352 12.7532 15.6459 12.6458C15.8699 12.5318 16.0105 12.3018 16.0105 12.0512C16.0105 11.8005 15.8699 11.5705 15.6459 11.4565H15.6452Z"
          fill="url(#paint2_linear_3348_10693)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3348_10693"
          x1="1.34387"
          y1="7.71213"
          x2="13.4325"
          y2="7.71213"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3348_10693"
          x1="11.7085"
          y1="3.76823"
          x2="15.6445"
          y2="3.76823"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3348_10693"
          x1="11.3452"
          y1="12.0508"
          x2="16.0105"
          y2="12.0508"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
        <clipPath id="clip0_3348_10693">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.676514)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
